export default "__VITE_ASSET__tFHQoCGU__"